module.exports = {
          srcSet: __webpack_public_path__ + "assets/e619fab511c0a7a335618e8ee4803dcd.webp"+" 63w",
          images:[ {path: __webpack_public_path__ + "assets/e619fab511c0a7a335618e8ee4803dcd.webp",width: 63,height: 63}],
          src: __webpack_public_path__ + "assets/e619fab511c0a7a335618e8ee4803dcd.webp",
          toString:function(){return __webpack_public_path__ + "assets/e619fab511c0a7a335618e8ee4803dcd.webp"},
          
          width: 63,
          height: 63
        }